(() => {
  const global = window;

  const $ = (sel, root = document) => root.querySelector(sel);

  const show = (el) => { if (el) el.style.display = ''; };
  const hide = (el) => { if (el) el.style.display = 'none'; };

  const escapeHtml = (str) => {
    const div = document.createElement('div');
    div.textContent = String(str ?? '');
    return div.innerHTML;
  };

  const postForm = async (url, dataObj) => {
    const body = new URLSearchParams();
    Object.entries(dataObj || {}).forEach(([k, v]) => body.append(k, v ?? ''));

    const res = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: body.toString(),
      credentials: 'same-origin',
    });

    return res.json();
  };

  // -------------------------
  // Util
  // -------------------------
  const Util = {
    getUrlParameter(name) {
      // краще через URLSearchParams
      try {
        const url = new URL(window.location.href);
        return url.searchParams.get(name) || '';
      } catch (e) {
        // fallback майже як у твоєму коді
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        const regex = new RegExp('[\\?&]' + name + '=([^&]*)');
        const results = regex.exec(location.href);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
      }
    },
  };

  // -------------------------
  // DocReferer
  // -------------------------
// -------------------------
// DocReferer
// -------------------------
const DocReferer = {
  SESSION_STORE_KEY: 'login_referer',

  _init() {
    this.$htmlUri = $('[name="checkout_url"]');
    if (this.$htmlUri) this.$htmlUri.value = this.getUri();
  },

  getUri() {
    let uri = this.getUriCache();

    if (!uri) uri = this._getReturnUrl();
    if (!uri) uri = this._getUri();

    if (uri && uri.indexOf('-recovery') > -1) uri = '/account';

    return uri || '';
  },

  _getReturnUrl() {
    let uri = Util.getUrlParameter('return_url');
    if (!uri || uri.indexOf('/') !== 0) return false;

    // ✅ не дозволяємо повертатися на register
    if (uri.indexOf('/account/register') === 0) return false;

    return uri;
  },

  _getUri() {
    let _uri = '';
    const htmlUri = this.$htmlUri ? this.$htmlUri.value : '';
    let uri = global.SnConf?.referer?.defUri;

    if (document.referrer && document.referrer.indexOf(window.location.origin) === 0) {
      _uri = document.referrer.replace(window.location.origin, '');
    }

    const cameFromRegister = _uri && _uri.indexOf('/account/register') === 0;

    if (htmlUri === global.SnConf?.referer?.cartUri) {
      uri = global.SnConf?.referer?.cartUri;
    } else if (_uri !== global.SnConf?.referer?.loginUri && _uri !== global.SnConf?.referer?.mainUri) {
      if (_uri.indexOf('/account/login') === -1) {

        // ✅ якщо прийшли з /account/register — НЕ записуємо login_referer
        if (cameFromRegister) {
          return uri; // залишаємо дефолт (або cart якщо спрацювало вище)
        }

        uri = _uri;
        this.setUriCache(uri);
      }
    }

    return uri;
  },

  getUriCache() {
    let uri = false;

    try {
      const uriData = JSON.parse(sessionStorage.getItem(this.SESSION_STORE_KEY));
      if (uriData && (Date.now() / 1000) - uriData.created < 100) {
        const cached = uriData.uri || '';

        // ✅ якщо в кеші вже лежить register — ігноруємо
        if (typeof cached === 'string' && cached.indexOf('/account/register') === 0) return false;

        uri = cached;
      }
    } catch (e) {}

    return uri;
  },

  setUriCache(uri) {
    const data = { uri, created: Date.now() / 1000 };
    try {
      sessionStorage.setItem(this.SESSION_STORE_KEY, JSON.stringify(data));
    } catch (e) {}
  },
};


  // -------------------------
  // Login
  // -------------------------
  const Login = {
    _init() {
      this.$errorBox = $('#snAuthError');
    },

    async login(snId, snType) {
      let gaId = '';

      if (typeof global.GaClientId !== 'undefined' && global.GaClientId?.getId) {
        gaId = global.GaClientId.getId();
      }

      if (this.$errorBox) {
        this.$errorBox.innerHTML = '';
        hide(this.$errorBox);
      }

      if (typeof grecaptcha === 'undefined' || !grecaptcha?.ready) {
        if (this.$errorBox) {
          this.$errorBox.textContent = global.SnConf?.msg?.errorLogin || 'Login error';
          show(this.$errorBox);
        }
        return;
      }

      grecaptcha.ready(() => {
        grecaptcha
          .execute(global.SnConf?.recaptcha_key_v3, { action: 'login_sn' })
          .then(async (token) => {
            try {
              const data = await postForm(global.SnConf?.url?.authSn, {
                sn_id: snId,
                sn_type: snType,
                cart_item_count: global.SnConf?.cartItemCount,
                uri: DocReferer.getUri(),
                ga_id: gaId,
                rec_token: token,
                rec_action: 'login_sn',
              });

              if (data?.loginUrl) {
                window.location.href = data.loginUrl;
                return;
              }

              const errors = [];
              if (Array.isArray(data?.errors)) {
                data.errors.forEach((err) => errors.push(escapeHtml(err)));
              } else if (data?.errors && typeof data.errors === 'object') {
                Object.values(data.errors).forEach((err) => errors.push(escapeHtml(err)));
              }

              if (this.$errorBox) {
                this.$errorBox.innerHTML = errors.length ? errors.join('<br />') : (global.SnConf?.msg?.errorLogin || 'Login error');
                show(this.$errorBox);
              }
            } catch (e) {
              if (this.$errorBox) {
                this.$errorBox.textContent = global.SnConf?.msg?.errorLogin || 'Login error';
                show(this.$errorBox);
              }
            }
          })
          .catch(() => {
            if (this.$errorBox) {
              this.$errorBox.textContent = global.SnConf?.msg?.errorLogin || 'Login error';
              show(this.$errorBox);
            }
          });
      });
    },
  };





  // -------------------------
  // DOM ready
  // -------------------------
  document.addEventListener('DOMContentLoaded', () => {
    Login._init();
    DocReferer._init();
  });
})();  